import type { TableTheme } from '../themes/theme-define';

export const themes: { [key: string]: TableTheme } = {};
